type Translator = (key: string, vars?: Record<string, string | number>) => string;

export function floorLabel(n: number, t: Translator): string {
  if (n === 0) return t("floor.ground");
  if (n === 1) return t("floor.1st");
  if (n === 2) return t("floor.2nd");
  if (n === 3) return t("floor.3rd");
  return t("floor.nth", { n });
}

export function floorLabelShort(n: number, t: Translator, maxLevel?: number): string {
  if (maxLevel !== undefined && n === maxLevel) return t("floor.roof");
  if (n === 0) return t("floor.short.ground");
  if (n === 1) return t("floor.short.1st");
  if (n === 2) return t("floor.short.2nd");
  if (n === 3) return t("floor.short.3rd");
  return t("floor.short.nth", { n });
}
